export default "__VITE_ASSET__I5J1q7EL__"